import { useSelector } from "react-redux";
import { AXNUIFormHelpTextContainer } from "@iddataweb/idw-common-ui/containers";
import { getConfigurationLayout, getGeneralTheme } from "@redux/selectors/verification-configuration-selectors";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import { useMemo } from "react";
import { getAXNUILayoutHelpTextParameters } from "@iddataweb/idw-common-ui/utils";
import { ThemingGenericContentSlotTypes } from "@iddataweb/idw-common-ui/enums";

export const PostSubmitFormHelpTextContainer = () => {
    const content = useSelector(getLanguageContent);
    const theme = useSelector(getGeneralTheme);
    const layout = useSelector(getConfigurationLayout);

    const helpTextParameters = useMemo(() => {
        if (layout?.helpText?.postSubmitButtonFormHelpText) {
            return getAXNUILayoutHelpTextParameters(content, layout, ThemingGenericContentSlotTypes.POST_SUBMIT_BUTTON_HELP_TEXT);
        }

        return null;
    }, [layout, content]);


    if (!layout?.helpText?.postSubmitButtonFormHelpText?.order?.length) {
        return null;
    }

    return (
        <AXNUIFormHelpTextContainer
            parameters={helpTextParameters}
            id={"postSubmitButtonFormHelpText"}
            isSubmitting={false}
            textColor={theme?.mainTextColor}
            fontFamily={theme?.font}
            buttonTextColor={theme?.mainButtonTextColor}
            buttonBackgroundColor={theme?.mainButtonBackgroundColor}
            linksColor={theme?.linksColor}
            content={content}
            explicitConsentChecked={false}
            setExplicitConsentChecked={() => { }}
        />
    );
};